import { Injectable } from '@angular/core';
import { DecimalPipe, PercentPipe, DatePipe } from '@angular/common';

@Injectable()
export class CommonToolService {
  constructor(
    private decimalPipe: DecimalPipe,
    private percentPipe: PercentPipe,
    private datePipe: DatePipe
  ) { }

  isNullOrUndefined(val) {
    if (val == null || val == undefined) {
      return true;
    }
    return false;
  }

  numberFormatter(value: number, format: string): string {
    return this.decimalPipe.transform(value, format);
  }

  percentFormatter(value: number, format: string) {
    return this.percentPipe.transform(value, format);
  }

  dateFormatter(value: Date, format: string) {
    return this.datePipe.transform(value, format);
  }

  getDisplayFileSize(byteSize: number, precision: number = 1) {
    var units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    var format = function (bytes, precision) {
      if (isNaN(parseFloat(bytes)) || bytes < 0) {
        return '-';
      }
      if (bytes === 0) {
        return '0 B';
      }

      // validate 'precision'
      if (isNaN(precision)) {
        precision = 1;
      }

      var unitIndex = Math.floor(Math.log(bytes) / Math.log(1024)),
        value = bytes / Math.pow(1024, unitIndex);

      return value.toFixed(precision) + ' ' + units[unitIndex];
    };

    return format(byteSize, precision);
  }
}
